import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {SynchronizationFacadeService} from '../synchronization-facade.service';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {SynchronizationConfiguration} from '../synchronization.reducer';

@Component({
  selector: 'app-synchronization-configuration-dropdown',
  template: `
      <app-input-dropdown *ngIf="configurations$ | async; else spinner"
                          [data]="configurations$ | async"
                          [inputControl]="control"
                          [includeIdInOptionView]="false"
                          [label]="'Synchronization configuration'"
                          (valueChange)="configurationSelectionChanged.emit($event)"
                          [placeholder]="'Synchronization configuration'">
      </app-input-dropdown>
      <ng-template #spinner>
          <mat-spinner [mode]="'indeterminate'"
                       [diameter]="25"></mat-spinner>
      </ng-template>
  `,
  styleUrls: ['./synchronization-configuration-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SynchronizationConfigurationDropdownComponent implements OnInit {
  control: FormControl = new FormControl('configurations');
  @Output() configurationSelectionChanged = new EventEmitter<SynchronizationConfiguration>();
  configurations$: Observable<SynchronizationConfiguration[]> = this.facade.selectConfigs()
    .pipe(
      shareReplay(1),
    );

  constructor(private facade: SynchronizationFacadeService) {
  }

  ngOnInit(): void {
  }

}
